<template>
  <div>
    <v-card class="card-custom-shadow">
      <v-card-text class="fs-12">
        <div class="fs-14px black--text mb-2">Tài sản thuê:</div>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              v-model.number="order.rent_day"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="Ngày thuê"
              type="number"
              @keypress="allowOnlyPositiveIntegers"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <Voucher
              v-model="order.id_voucher"
              :vouchers="vouchers"
              :id-country="info.id_country"
              :id-voucher="info.id_voucher"
              label="Voucher"
              class="c-input-small"
            />
            <!-- <v-autocomplete
              v-model="order.id_voucher"
              class="c-input-small"
              :items="voucherOptions"
              dense
              outlined
              hide-details
              label="Voucher"
            ></v-autocomplete> -->
          </v-col>
          <v-col cols="4">
            <select-branch-model
              v-model="order.id_branch"
              class="c-input-small"
              dense
              outlined
              hide-details
              label="Cơ sở"
              :auto-select="true"
            ></select-branch-model>
          </v-col>
          <v-col cols="8">
            <input-qr-scan-model
              v-model="code"
              ref="codeRef"
              label="Quét mã tài sàn"
              :disabled="!order.id_branch || !order.rent_day"
              :auto-close="false"
              @keyupEnter="scanInput"
            ></input-qr-scan-model>
          </v-col>
          <v-col cols="12">
            <v-simple-table class="table-padding-2 table-h-36 mb-2">
              <template v-slot:default>
                <thead class="v-data-table-header">
                  <tr>
                    <th
                      role="columnheader"
                      class="text-center"
                      style="width: 75px"
                    >
                      Mã
                    </th>
                    <th
                      role="columnheader"
                      class="text-center"
                      style="width: 75px"
                    >
                      Loại tài sản
                    </th>
                    <th role="columnheader" class="text-center">Tài sản</th>
                    <th
                      role="columnheader"
                      class="text-center"
                      style="width: 36px; min-width: 36px"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in order.items"
                    :key="`i_${index}_${item.id}`"
                    class="text-center"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.asset_type_name }}</td>
                    <td>
                      {{ item.asset_name }}
                      <span v-if="item.keys" class="primary--text">
                        (Chía khóa: {{ item.keys }})
                      </span>
                    </td>
                    <td style="width: 30px; min-width: 30px">
                      <v-icon
                        color="error"
                        class="cursor-pointer"
                        @click="removeItem(item)"
                      >
                        mdi-close
                      </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ORDER_CREATE_DEFAULT_ITEM, ASSET_TYPE } from "@/libs/const";
import { httpClient } from "@/libs/http";

export default {
  name: "Items",
  components: {
    Voucher: () => import("@/components/rent/Voucher"),
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    vouchers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    order: { ...ORDER_CREATE_DEFAULT_ITEM },
    code: null,
    isLoading: false,
  }),
  computed: {
    scannedCodes() {
      if (!this.order.items || this.order.items.length === 0) {
        return [];
      }

      return [...this.order.items].map((item) => item.code);
    },
    voucherOptions() {
      if (!this.vouchers || this.vouchers.length === 0) {
        return [];
      }

      return [...this.vouchers]
        .filter((voucher) => voucher.id_country == this.info.id_country)
        .map((voucher) => ({
          text: `${voucher.code} - ${voucher.name}`,
          value: voucher.id,
        }));
    },
  },
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.info && this.info.id) {
      this.order = {
        ...this.order,
        id_voucher: this.info.id_voucher,
        id_branch: this.info.id_branch,
        rent_day: this.info.rent_day,
        items: this.info.items,
      };
    }
  },
  methods: {
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_ITEM, items: [] };
    },
    removeItem(item) {
      const child = [...this.order.items].find(
        (jtem) => jtem.id_asset_uid_parent == item.id
      );

      if (child) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(
          this.$t(
            "Không thể xóa tài sản cha khi còn có tài sản con (VD: Xe - Chìa khóa)"
          )
        );
        return false;
      }

      this.order.items = [...this.order.items].filter(
        (jtem) => jtem.id != item.id
      );
    },
    async scanInput() {
      if (!this.code) {
        return false;
      }

      const code = this.code.toUpperCase();

      if (this.scannedCodes.includes(code)) {
        this.code = null;
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Mã đã quét"));
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        const { data } = await httpClient.post("/asset/v1/find-uid-by-code", {
          code: code,
          is_check_available: true,
        });
        this.code = null;
        this.isLoading = false;

        console.log(this.summary);
        if (
          data.id_asset_type == ASSET_TYPE.BIKE &&
          this.summary.count_bike >= this.summary.max_bike
        ) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(this.$t("SL xe đã tối đa"));
          return false;
        }

        if (
          data.id_asset_type == ASSET_TYPE.KEY &&
          this.summary.count_key >= this.summary.max_key
        ) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(this.$t("SL chìa khóa đã tối đa"));
          return false;
        }

        if (
          data.id_asset_type == ASSET_TYPE.CHARGER &&
          this.summary.count_charger >= this.summary.max_charger
        ) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(this.$t("SL sạc đã tối đa"));
          return false;
        }

        if (
          data.id_asset_type == ASSET_TYPE.HELMET &&
          this.summary.count_helmet >= this.summary.max_helmet
        ) {
          document.getElementById("error_sound_player").play();
          this.$vToastify.error(this.$t("SL mũ đã tối đa"));
          return false;
        }

        if (data.id_asset_uid_parent) {
          const parent = [...this.order.items].find(
            (item) => item.id === data.id_asset_uid_parent
          );
          if (!parent) {
            document.getElementById("error_sound_player").play();
            this.$vToastify.error(
              this.$t(
                "Chưa quét tài sản cha hoặc tài sản con không đúng (VD: Xe - Chìa khóa)"
              )
            );
            return false;
          }
        }

        this.order.items.push(data);
        document.getElementById("success_sound_player").play();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
